import axios from 'axios';

import { urls } from '~/preloaded';
import settings from '~/settings';
import { TYPE_GLOBAL_SEARCH } from '~/constants';
import { get } from '~/helpers/api';

import { autocompleteActions } from '~/store/slices/autocompleteSlice';

import type { AppAsyncThunk } from '~/store';
import type { IApiAutocompletePayload, IApiAutocompleteResponse, IApiError } from '~/types/api';

interface IFetchAutocompleteResult {
  term: string;
  type?: string;
  abortSignal?: AbortController['signal'];
}

export const fetchAutompleteResultThunk =
  ({ term, type, abortSignal }: IFetchAutocompleteResult): AppAsyncThunk =>
  async (dispatch, getState) => {
    const state = getState();

    dispatch(autocompleteActions.clearResult());

    if (term.length < settings.search.minChars) {
      return;
    }

    let url: string;
    let query: IApiAutocompletePayload = {};

    const realm = state.clansRating.currentRealm || TYPE_GLOBAL_SEARCH;

    if (type === 'clansRating') {
      url = urls.ladderClanSearchAutocomplete.replace('{query}', term);
      url = `${url}&season=${state.clansRating.currentSeason}&realm=${realm}`;
    } else {
      url = urls.searchAutocomplete;
      query = {
        search: term,
        type: 'clans',
      };
    }

    try {
      dispatch(autocompleteActions.startFetching());
      const result = await get<IApiAutocompleteResponse>(url, query, abortSignal && { signal: abortSignal });
      if (result.error) {
        throw result.error;
      }

      const data = { ...result, term };
      dispatch(autocompleteActions.processSuccessfulResponse(data));
    } catch (error: unknown) {
      if (!axios.isCancel(error)) {
        dispatch(autocompleteActions.processFailedResponse(error as IApiError));
      }
    }
  };
